import React, { useState } from "react";
import { ProblemsDictionary } from "../../types/Metadata";
import { Button } from "../../components/ui/button";

const Modal = ({
  headerTitle,
  setShowModal,
  saveItem,
  val = "",
}: {
  headerTitle: string;
  setShowModal: any;
  saveItem: (name: string) => void;
  val?: string;
}) => {
  const [value, setValue] = useState<string>(val);
  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-40 bg-black/25" onClick={() => setShowModal(false)} />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-[var(--sc-surface)] rounded-[14px] w-[480px] shadow-[0_20px_60px_rgba(0,0,0,0.18)] flex flex-col">

          {/* Header */}
          <div className="flex items-center justify-between px-5 pt-5 pb-4 border-b border-[var(--sc-border)]">
            <h3 className="text-[15px] font-semibold text-[var(--sc-text)]">{headerTitle}</h3>
            <button
              className="w-7 h-7 rounded-[6px] border border-[var(--sc-border)] flex items-center justify-center text-[var(--sc-muted)] hover:text-[var(--sc-text)] hover:bg-[var(--sc-bg)] text-sm transition-colors"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
          </div>

          {/* Body */}
          <div className="px-5 py-4">
            <textarea
              autoFocus
              className="w-full min-h-[80px] rounded-[6px] border border-[var(--sc-border)] bg-[#F2F2F0] px-3 py-2 text-sm text-[var(--sc-text)] placeholder:text-[var(--sc-muted)] focus:outline-none focus:bg-[#EAF0F8] focus:border-[#99AECB] resize-none transition-colors"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-2 px-5 pb-5">
            <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>
              Zamknij
            </Button>
            <Button size="sm" onClick={() => { saveItem(value); setShowModal(false); }}>
              Zapisz
            </Button>
          </div>

        </div>
      </div>
    </>
  );
};

export default function AddItemModal({
  saveItem,
  text,
  children,
  borderless = false,
  val = "",
  variant,
}: {
  text: string;
  saveItem: (name: string) => void;
  children?: any;
  problemsDictionary?: ProblemsDictionary;
  borderless?: boolean;
  val?: string;
  variant?: "default" | "secondary" | "ghost" | "destructive" | "dark";
}) {
  const [showModal, setShowModal] = React.useState(false);
  const resolvedVariant = variant ?? (borderless ? "ghost" : "secondary");
  return (
    <>
      {showModal && (
        <Modal
          val={val}
          headerTitle={text}
          saveItem={saveItem}
          setShowModal={setShowModal}
        />
      )}

      <Button variant={resolvedVariant} size="sm" onClick={() => setShowModal(true)}>
        {children ?? text}
      </Button>
    </>
  );
}
